"use strict";

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Map } from 'immutable';
import { AppDispatcher } from 'Dispatcher';
import { FormEditConstants } from "Constants/Forms/FormEditConstants";
import { formEditSubmited } from "Actions/Forms/FormEditActions";
import { FormConstants } from "Constants/Forms/FormConstants";
import { ApplicationConstants } from "Constants/ApplicationConstants";
import { D5TableConstants } from "Constants/Table/D5TableConstants";

var FormEditContainerClass =
/*#__PURE__*/
function () {
  function FormEditContainerClass() {
    _classCallCheck(this, FormEditContainerClass);

    _defineProperty(this, "_stores", new Map());
  }

  _createClass(FormEditContainerClass, [{
    key: "create",
    value: function create(options) {
      var formUUID = options.formUUID,
          store = options.store;
      this._stores = this._stores.set(formUUID, store);
      store.initialize(options);
    }
  }, {
    key: "del",
    value: function del(_ref) {
      var formUUID = _ref.formUUID;
      this._stores = this._stores.delete(formUUID);
    }
  }, {
    key: "get",
    value: function get(formUUID) {
      return this._stores.get(formUUID);
    }
  }, {
    key: "formEditUpdate",
    value: function formEditUpdate(_ref2) {
      var formUUID = _ref2.formUUID,
          rest = _objectWithoutProperties(_ref2, ["formUUID"]);

      var store = this.get(formUUID);
      store && store.formEditUpdate(rest);
    }
  }, {
    key: "submitForm",
    value: function submitForm(_ref3) {
      var formUUID = _ref3.formUUID,
          applyMode = _ref3.applyMode;
      var store = this.get(formUUID);
      store && store.submitForm(applyMode).then(function (data) {
        if (data) formEditSubmited({
          data: data,
          mode: store.mode,
          formUUID: store.parentUUID
        });
      });
    }
  }, {
    key: "receiveNestedData",
    value: function receiveNestedData(_ref4) {
      var parentFormID = _ref4.parentFormID,
          rest = _objectWithoutProperties(_ref4, ["parentFormID"]);

      this._stores.forEach(function (form) {
        if (form.formID === parentFormID) form.receiveNestedData(rest);
      });
    }
  }, {
    key: "nestedFormLoaded",
    value: function nestedFormLoaded(_ref5) {
      var parentFormID = _ref5.parentFormID,
          rest = _objectWithoutProperties(_ref5, ["parentFormID"]);

      this._stores.forEach(function (form) {
        if (form.formID === parentFormID) form.nestedFormLoaded(rest);
      });
    }
  }, {
    key: "navigateToParent",
    value: function navigateToParent(_ref6) {
      var formUUID = _ref6.formUUID;
      var store = this.get(formUUID);
      store && store.navigateToParentAction();
    }
  }, {
    key: "formEditUpdateSubForm",
    value: function formEditUpdateSubForm(_ref7) {
      var formUUID = _ref7.formUUID,
          table = _ref7.table;
      var store = this.get(formUUID);
      store && store.formEditUpdateSubForm(table);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          formUUID = _ref8.formUUID;

      if (formUUID != null) this.del({
        formUUID: formUUID
      });else this._stores.clear();
    }
  }]);

  return FormEditContainerClass;
}();

export var FormEditContainer = new FormEditContainerClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case FormEditConstants.FORM_EDIT_INITIALIZE:
      FormEditContainer.create(action.options);
      break;

    case FormEditConstants.FORM_EDIT_UPDATE:
      FormEditContainer.formEditUpdate(action);
      break;

    case FormEditConstants.FORM_EDIT_DESTROY:
      FormEditContainer.destroy(action);
      break;

    case FormEditConstants.FORM_EDIT_NESTED_FORM_LOADED:
      FormEditContainer.nestedFormLoaded(action);
      break;

    case FormConstants.FORM_SUBMIT:
      FormEditContainer.submitForm(action);
      break;

    case FormConstants.NAVIGATE_TO_PARENT:
      FormEditContainer.navigateToParent(action);
      break;

    case FormEditConstants.FORM_EDIT_UPDATE_SUBFORM:
      FormEditContainer.formEditUpdateSubForm(action);
      break;

    case D5TableConstants.D5_SEND_NESTED_DATA:
      FormEditContainer.receiveNestedData(action.options);
      break;

    case ApplicationConstants.DO_LOGOUT:
      {
        FormEditContainer.destroy();
        break;
      }

    default:
      return true;
  }
});